// extracted by mini-css-extract-plugin
module.exports = {"main_block":"stack_main_block__ZIye7","container":"stack_container__1Tl9-","item":"stack_item__2gcdg","heading":"stack_heading__H_sv2"};